var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMe),expression:"showMe"}],staticClass:"btn",on:{"click":_vm.handleViewAll}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icons/icon_gridview_outline.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('editButtonOrderPageViewAll')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }